import * as React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";

import InputLabel from "@mui/material/InputLabel";
import Select from "react-select";

function SelectStudentListsDialog({ onClose, onOK, open, studentLists }) {
  const [_selectedList, setSelectedList] = React.useState("XX");

  const handleClose = () => {
    onClose();
  };

  const handleOK = () => {
    onOK(_selectedList);
  };

  const handleSelect = (value) => {
    setSelectedList(value);
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          width: 600,
          height: 250
        },
      }}
      onClose={handleClose}
      open={open}
      fullScreen={true}
    >
      <DialogTitle id="select-student-list-dialog-title">
        Select Student List
      </DialogTitle>

      <DialogContent>
        <InputLabel>Select Student List</InputLabel>
        <Select
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          options={studentLists}
          onChange={handleSelect}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleOK}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SelectStudentListsDialog;
